import { CardString, Suit, Value } from 'pokersolver'
import { StyleSheet, useWindowDimensions, View } from 'react-native'

//import { verticalScale } from '../../../styles/sizes'
import { Card } from '../Card'
import { WalkthroughType } from '../../../models/game/walkthrough'
import { useCallback, useMemo } from 'react'
import { useResponsive } from '@/screens/new-design/hooks'
import { Indicator } from '@/components/ANewDesign/Indicator/Indicator'
import { useMaxWidth } from '@/components/WebWrapper'
import { PokerCard } from '@/components/GameAssets/Cards/PokerCard'

interface ShowCardsInterface {
  channelName?: string
  leftCardShown?: boolean
  rightCardShown?: boolean
  userId?: string
  _id?: string
}

interface PlayerCellCardsProps {
  cards: CardString[]
  showOrHideCards: boolean
  walkthroughType: WalkthroughType | undefined
  isMyFirstGame?: boolean
  showCards?: ShowCardsInterface
  right?: boolean
  applyOpacity?: boolean
  isMyPlayerFolded: boolean
  showIndicator?: boolean
}

export const PlayerCellCards = ({
  showCards,
  cards,
  right,
  walkthroughType,
  applyOpacity,
  showOrHideCards,
  isMyPlayerFolded,
  showIndicator,
  isMyFirstGame
}: PlayerCellCardsProps) => {
  const { width } = useWindowDimensions()
  const isMyFirstGameInLargerScreen = width >= 640 && isMyFirstGame

  const { verticalScale } = useResponsive({
    minVerticalScale: 0.7,
    maxVerticalScale: isMyFirstGameInLargerScreen ? 0.85 : 1.2
  })

  const renderLeftCard = useCallback(() => {
    if (showOrHideCards && !isMyPlayerFolded) {
      return cards[0]
    }

    if (showCards?.leftCardShown) {
      return cards[0]
    }

    return
  }, [showCards, cards, showOrHideCards, isMyPlayerFolded])

  const renderRightCard = useCallback(() => {
    if (showOrHideCards && !isMyPlayerFolded) {
      return cards[1]
    }

    if (showCards?.rightCardShown) {
      return cards[1]
    }

    return
  }, [showCards, cards, showOrHideCards, isMyPlayerFolded])

  return (
    <View style={[styles.container, right ? styles.right : {}, { opacity: applyOpacity ? 0.4 : 1 }]}>
      {showIndicator ? <Indicator /> : null}
      <Card
        card={renderLeftCard()}
        fontSize={walkthroughType || isMyFirstGameInLargerScreen ? verticalScale(16) : verticalScale(10)}
      />
      <Card
        card={renderRightCard()}
        fontSize={walkthroughType || isMyFirstGameInLargerScreen ? verticalScale(16) : verticalScale(10)}
      />
    </View>
  )
}
export const PlayerCellCards2 = ({
  showCards,
  cards,
  right,
  walkthroughType,
  applyOpacity,
  showOrHideCards,
  isMyPlayerFolded,
  showIndicator,
  isMyFirstGame
}: PlayerCellCardsProps) => {
  const { width } = useWindowDimensions()
  const isMyFirstGameInLargerScreen = width >= 640 && isMyFirstGame

  const { verticalScale } = useResponsive({
    minVerticalScale: 0.7,
    maxVerticalScale: isMyFirstGameInLargerScreen ? 0.85 : 1.2
  })

  const leftCard = useMemo(() => {
    if (showOrHideCards && !isMyPlayerFolded) {
      return cards[0]
    }
    if (showCards?.leftCardShown) {
      return cards[0]
    }
    return
  }, [showCards, cards, showOrHideCards, isMyPlayerFolded])

  const rightCard = useMemo(() => {
    if (showOrHideCards && !isMyPlayerFolded) {
      return cards[1]
    }
    if (showCards?.rightCardShown) {
      return cards[1]
    }
    return
  }, [showCards, cards, showOrHideCards, isMyPlayerFolded])

  return (
    <View style={[styles.container, right ? styles.right : {}, { opacity: applyOpacity ? 0.4 : 1 }]}>
      {showIndicator ? <Indicator /> : null}
      <PokerCard.Flip
        suit={leftCard?.[1] as Suit | undefined}
        value={leftCard?.[0] as Value | undefined}
        size={walkthroughType || isMyFirstGameInLargerScreen ? verticalScale(32) : verticalScale(20)}
        side={leftCard ? 'front' : 'back'}
      />
      <PokerCard.Flip
        suit={rightCard?.[1] as Suit | undefined}
        value={rightCard?.[0] as Value | undefined}
        size={walkthroughType || isMyFirstGameInLargerScreen ? verticalScale(32) : verticalScale(20)}
        side={rightCard ? 'front' : 'back'}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 2
  },
  right: {
    justifyContent: 'flex-end'
  }
})
